import React, { useState, useEffect } from 'react';
import { Box, darken, Grid, Hidden, Toolbar } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';
/* import clsx from 'clsx'; */
import Logo from '../../partials/Logo';

import SidebarToggleHandler from '../../../../../@coremat/CmtLayouts/Horizontal/SidebarToggleHandler';
//import AppsMenu from '../../partials/Header/AppsMenu';
// import HeaderMessages from '../../partials/Header/HeaderMessages';
/* import HeaderNotifications from '../../partials/Header/HeaderNotifications'; */
// import LanguageSwitcher from '../../partials/LanguageSwitcher';
/* import SearchPopover from '../../partials/SearchPopover'; */
import UserDropDown from '../../partials/UserDropDown';
import CmtHorizontal from '../../../../../@coremat/CmtNavigation/Horizontal';
// import { minimalHorizontalMenus } from '../../partials/menus';
import { menusCollapse } from '../../partials/menus.dynamic.header';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import Countdown from 'react-countdown';
import { CULogOut } from 'redux/actions/ClaveUnicaActions';
import { useDispatch } from 'react-redux';
import { SESSION_TIMER } from 'services/api';
import { useHistory } from 'react-router-dom';
import { URL_DEFAULT } from 'config/config';
/* import { toast } from '@jumbo/components/custom/Toast'; */
import SessionModal from '@jumbo/components/custom/SessionModal';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    padding: 0,
    minHeight: 10,
    [theme.breakpoints.down('md')]: {
      paddingTop: 12,
      paddingBottom: 12,
    },
    '& .Cmt-appIcon': {
      color: theme.palette.text.secondary,
      '&:hover, &:focus': {
        color: darken(theme.palette.text.secondary, 0.2),
      },
      [theme.breakpoints.down('xs')]: {
        padding: 7,
      },
    },
    '& .Cmt-horizontalNavMenu': {
      position: 'static',
      '& .Cmt-navMegaBtn, & > .Cmt-navCollapse > .Cmt-navCollapseBtn': {
        minHeight: 64,
      },
    },
  },
  langRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 5,
    paddingRight: 5,
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      paddingLeft: 15,
      paddingRight: 15,
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 2,
      zIndex: 1,
      height: 35,
      width: 1,
      backgroundColor: alpha(theme.palette.common.dark, 0.15),
    },
  },
  searchIcon: {
    [theme.breakpoints.down('xs')]: {
      padding: 9,
    },
  },
}));

const MainHeader = () => {
  const classes = useStyles();
  const { user } = useSelector(({ claveUnica }) => claveUnica);
  const [menu, setMenu] = useState([]);
  const startDate = React.useRef(Date.now());
  const [expireTime, setExpireTime] = useState(startDate.current + SESSION_TIMER);
  const [countDownKey, setCountDownKey] = useState(0);
  const location = useLocation();
  let history = useHistory();
  const dispatch = useDispatch();
  const [isLogged, setIsLogged] = useState(false);

  const renderer = ({ formatted: { hours, minutes, seconds }, completed }) => {
    if (completed) {
      //toast.warn('Ha expirado la sesión');
      setTimeout(() => {
        setIsLogged(true);
      }, 1000);

      return <span>sesión expirada</span>;
    } else {
      return (
        <span>
          {'Su sesión finaliza en: ' + minutes}:{seconds}
        </span>
      );
    }
  };

  useEffect(() => {
    var auxUser = {};
    try {
      auxUser = JSON.parse(user);
    } catch (error) {
      auxUser = user;
    }
    setMenu(menusCollapse(auxUser, location.pathname));
  }, [user, location]);

  const closeModal = () => {
    dispatch(CULogOut());
    history.push(URL_DEFAULT);
    //setIsLogged(false)
  };

  const stayLoggedIn = () => {
    const newDate = Date.now();
    setExpireTime(newDate + SESSION_TIMER);
    setIsLogged(false);
    setCountDownKey(countDownKey + 1);
  };

  return (
    <Toolbar className={classes.root}>
      <SessionModal openDialog={isLogged} close={closeModal} submit={stayLoggedIn} />
      <SidebarToggleHandler edge="start" color="inherit" aria-label="menu" />
      <Logo mr={{ xs: 2, sm: 4, lg: 6, xl: 8 }} color="white" />

      {menu && (
        <Hidden mdDown>
          <CmtHorizontal menuItems={menu} />
        </Hidden>
      )}

      <Box display="flex" alignItems="center" ml="auto">
        {/* <SearchPopover iconClassName={clsx(classes.searchIcon, 'Cmt-searchIcon')} /> */}
        <Grid container style={{ marginRight: 10 }}>
          <Countdown key={countDownKey} date={expireTime} renderer={renderer} />
        </Grid>
        {/*  <AppsMenu /> */}
        {/* <HeaderMessages /> */}
        {/* <HeaderNotifications /> */}
        {/* <Box className={clsx(classes.langRoot, 'Cmt-i18n-switch')}>
          <LanguageSwitcher />
        </Box> */}
        <UserDropDown />
      </Box>
    </Toolbar>
  );
};

export default MainHeader;
